import Axios from "axios";
import { SET_INV_ITEM_RECEIVED_REPORT, UNSET_INV_ITEM_RECEIVED_REPORT } from "@/store/mutation-types";
import { getInvItemReceivedReport } from "@/store/api";

const state = { getInvItemReceivedReport: {} };

const getters = {
  getInvItemReceivedReport(state) {
    return state.getInvItemReceivedReport;
  },
};

const mutations = {
  [SET_INV_ITEM_RECEIVED_REPORT](state, data) {
    state.getInvItemReceivedReport = data;
  },
  [UNSET_INV_ITEM_RECEIVED_REPORT](state) {
    state.getInvItemReceivedReport = {};
  },
};

const actions = {
  getInvItemReceivedReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvItemReceivedReport, { params: data })
        .then(function (response) {
          commit("SET_INV_ITEM_RECEIVED_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_ITEM_RECEIVED_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default { state, getters, actions, mutations };
